import RadioButtonControlGroup from "../../../../../shared/RadioButtonControlGroup";
import SelectField from "../../../../common/SelectField";

/**
 * Static RBP administrator dropdown options (synthetic).
 * @readonly
 */
export const RBP_ADMINISTRATOR_OPTIONS = Object.freeze([
    "Payer Compass",
    "Asserta Health",
    "6 Degrees Health",
    "None",
]);


/**
 * Static third-party network dropdown options (synthetic).
 * @readonly
 */
export const THIRD_PARTY_NETWORK_OPTIONS = Object.freeze([
    "Cigna PPO",
    "PHCS",
    "HealthSmart",
    "None",
]);

const VPC_OPTIONS = [
    { value: "no", label: "No" },
    { value: "yes", label: "Yes" },
];

/**
 * External/RBP network subform: RBP administrator and third-party network
 * dropdowns, plus a VPC-module question when the row needs it. Presentational —
 * selections flow up via callbacks; owns no state.
 *
 * @param {object} props
 * @param {string} props.rbpAdministrator
 * @param {string} props.thirdPartyNetwork
 * @param {boolean | null} props.requireVpcModule
 * @param {boolean} props.needsVpc - Whether the VPC question applies.
 * @param {(field: string, value: *) => void} props.onFieldChange
 * @returns {import('react').JSX.Element}
 */
const ExternalNetworkFields = ({
    rbpAdministrator,
    thirdPartyNetwork,
    requireVpcModule,
    needsVpc,
    onFieldChange,
}) => {
    const vpcValue =
        requireVpcModule === true
            ? "yes"
            : requireVpcModule === false
              ? "no"
              : null;

    return (
        <div className="config-external-fields">
            <SelectField
                id="rbp-administrator"
                label="RBP administrator"
                value={rbpAdministrator ?? ""}
                onChange={(value) => onFieldChange("rbpAdministrator", value)}
                placeholderOption="Select"
                options={RBP_ADMINISTRATOR_OPTIONS.map((option) => ({
                    value: option,
                    label: option,
                }))}
            />

            <SelectField
                id="third-party-network"
                label="Third party network"
                value={thirdPartyNetwork ?? ""}
                onChange={(value) => onFieldChange("thirdPartyNetwork", value)}
                placeholderOption="Select"
                options={THIRD_PARTY_NETWORK_OPTIONS.map((option) => ({
                    value: option,
                    label: option,
                }))}
            />

            {needsVpc ? (
                <div className="config-external-fields__vpc">
                    <span className="config-field__label">
                        Does this site require VPC module?
                    </span>
                    <RadioButtonControlGroup
                        ariaLabel="Require VPC module"
                        value={vpcValue}
                        onChange={(value) =>
                            onFieldChange("requireVpcModule", value === "yes")
                        }
                        options={VPC_OPTIONS}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default ExternalNetworkFields;
